import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Kicker } from "@/components/Reveal";
import { CLIENTS } from "@/data/content";

const Clients = () => {
  const { t, dir } = useLang();

  return (
    <section id="clients" data-testid="clients-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <Reveal><Kicker>{t.clients.kicker}</Kicker></Reveal>
          <Reveal delay={0.1}>
            <h2
              style={{ lineHeight: dir === "rtl" ? 1.25 : 1.1 }}
              className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1A1A1A] mt-5"
            >
              {t.clients.title}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 border-t border-s border-[#E5DFD3]">
          {CLIENTS.map((client, i) => (
            <Reveal key={i} delay={(i % 5) * 0.06}>
              <div
                data-testid={`client-${i}`}
                className="group h-32 md:h-40 flex items-center justify-center border-b border-e border-[#E5DFD3] p-6 bg-white"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-16 md:max-h-20 w-auto object-contain grayscale opacity-90 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
